export interface Category {
  id: string;
  nameKey: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'categories.shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20crisp%20white%20and%20sage%20green%20retro%20running%20sneakers%20floating%20on%20a%20warm%20terracotta%20studio%20backdrop%20with%20soft%20directional%20lighting%20and%20gentle%20shadow%2C%20minimalist%20product%20photography%2C%20premium%20sneaker%20editorial%20aesthetic%2C%20crisp%20details%2C%20clean%20composition&width=600&height=600&seq=cat-shoes-01&orientation=square&nocache=true',
  },
  {
    id: 'hoodies',
    nameKey: 'categories.hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20cream%20hoodie%20draped%20over%20a%20wooden%20hanger%20against%20a%20soft%20muted%20sage%20green%20wall%2C%20warm%20natural%20window%20light%2C%20minimal%20apparel%20editorial%20photography%2C%20textured%20cotton%20fabric%20detail%2C%20calm%20airy%20atmosphere%2C%20clean%20composition&width=600&height=600&seq=cat-hoodies-01&orientation=square&nocache=true',
  },
  {
    id: 'tshirts',
    nameKey: 'categories.tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20stack%20of%20pastel%20cotton%20t-shirts%20in%20blush%20pink%20and%20pale%20blue%20tones%20on%20a%20light%20linen%20surface%2C%20soft%20diffused%20daylight%2C%20minimal%20fashion%20flat%20lay%20photography%2C%20crisp%20fabric%20folds%2C%20airy%20and%20fresh%20mood%2C%20clean%20balanced%20composition&width=600&height=600&seq=cat-tshirts-01&orientation=square&nocache=true',
  },
  {
    id: 'jackets',
    nameKey: 'categories.jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloud-line',
    image: 'https://readdy.ai/api/search-image?query=A%20tailored%20olive%20green%20bomber%20jacket%20displayed%20on%20a%20minimal%20wooden%20mannequin%20against%20a%20warm%20sand%20plaster%20wall%2C%20soft%20golden%20hour%20lighting%2C%20premium%20outerwear%20editorial%20photography%2C%20rich%20fabric%20texture%2C%20elegant%20warm%20atmosphere%2C%20clean%20composition&width=600&height=600&seq=cat-jackets-01&orientation=square&nocache=true',
  },
  {
    id: 'pants',
    nameKey: 'categories.pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-brush-line',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20relaxed%20fit%20stone%20washed%20denim%20jeans%20folded%20neatly%20on%20a%20pale%20blue%20grey%20surface%20with%20a%20small%20woven%20basket%20beside%2C%20soft%20natural%20light%2C%20minimal%20fashion%20flat%20lay%2C%20detailed%20denim%20stitching%20and%20texture%2C%20calm%20modern%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-pants-01&orientation=square&nocache=true',
  },
  {
    id: 'headwear',
    nameKey: 'categories.headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20unstructured%20dad%20cap%20in%20warm%20caramel%20brown%20resting%20on%20a%20pale%20cream%20pedestal%20with%20a%20soft%20beanie%20behind%20it%2C%20gentle%20studio%20lighting%2C%20minimal%20headwear%20product%20photography%2C%20tactile%20fabric%20detail%2C%20warm%20cozy%20atmosphere%2C%20clean%20composition&width=600&height=600&seq=cat-headwear-01&orientation=square&nocache=true',
  },
  {
    id: 'sets',
    nameKey: 'categories.sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20two%20piece%20lilac%20loungewear%20set%20folded%20on%20a%20light%20stone%20surface%20with%20a%20soft%20lavender%20backdrop%2C%20airy%20natural%20light%2C%20minimal%20matching%20outfit%20editorial%20photography%2C%20delicate%20fabric%20texture%2C%20serene%20soft%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-sets-01&orientation=square&nocache=true',
  },
  {
    id: 'underwear',
    nameKey: 'categories.underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-layout-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20mint%20green%20cotton%20underwear%20and%20basics%20arranged%20in%20a%20tidy%20grid%20on%20a%20light%20neutral%20background%20with%20a%20small%20eucalyptus%20sprig%2C%20soft%20diffused%20daylight%2C%20minimal%20undergarment%20flat%20lay%20photography%2C%20gentle%20fabric%20folds%2C%20fresh%20clean%20mood%2C%20balanced%20composition&width=600&height=600&seq=cat-underwear-01&orientation=square&nocache=true',
  },
  {
    id: 'jersey',
    nameKey: 'categories.jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-trophy-line',
    image: 'https://readdy.ai/api/search-image?query=A%20bold%20athletic%20soccer%20jersey%20with%20a%20large%20number%20seven%20hanging%20on%20a%20metal%20rail%20against%20a%20warm%20sand%20textured%20wall%2C%20dramatic%20soft%20spotlight%2C%20premium%20sportswear%20editorial%20photography%2C%20crisp%20mesh%20fabric%20detail%2C%20energetic%20yet%20clean%20mood%2C%20balanced%20composition&width=600&height=600&seq=cat-jersey-01&orientation=square&nocache=true',
  },
  {
    id: 'accessories',
    nameKey: 'categories.accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-sparkling-line',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20arrangement%20of%20aviator%20sunglasses%2C%20a%20minimalist%20watch%20and%20a%20leather%20bracelet%20on%20a%20soft%20peach%20surface%20with%20gentle%20shadows%2C%20warm%20natural%20light%2C%20premium%20accessory%20flat%20lay%20photography%2C%20refined%20metal%20and%20leather%20textures%2C%20elegant%20warm%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-accessories-01&orientation=square&nocache=true',
  },
  {
    id: 'bags',
    nameKey: 'categories.bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=A%20structured%20cognac%20brown%20leather%20backpack%20standing%20upright%20on%20a%20warm%20camel%20backdrop%20with%20a%20small%20canvas%20tote%20beside%20it%2C%20soft%20studio%20lighting%2C%20premium%20bag%20product%20photography%2C%20rich%20leather%20grain%20detail%2C%20warm%20sophisticated%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-bags-01&orientation=square&nocache=true',
  },
  {
    id: 'belts',
    nameKey: 'categories.belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-loop-left-line',
    image: 'https://readdy.ai/api/search-image?query=A%20coiled%20natural%20tan%20leather%20belt%20with%20a%20brushed%20brass%20buckle%20arranged%20elegantly%20on%20a%20muted%20olive%20green%20surface%2C%20soft%20directional%20light%2C%20minimal%20leather%20accessory%20photography%2C%20rich%20grain%20and%20metal%20detail%2C%20refined%20earthy%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-belts-01&orientation=square&nocache=true',
  },
  {
    id: 'perfumes',
    nameKey: 'categories.perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-flower-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20elegant%20amber%20glass%20perfume%20bottle%20with%20gold%20cap%20on%20a%20soft%20rose%20silk%20backdrop%20surrounded%20by%20delicate%20dried%20flowers%2C%20warm%20cinematic%20lighting%2C%20luxury%20fragrance%20product%20photography%2C%20glossy%20glass%20reflections%2C%20romantic%20refined%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-perfumes-01&orientation=square&nocache=true',
  },
  {
    id: 'other',
    nameKey: 'categories.other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20flat%20lay%20of%20assorted%20lifestyle%20goods%20including%20a%20phone%20case%2C%20keychain%2C%20socks%20and%20a%20small%20notebook%20on%20a%20warm%20grey%20textured%20surface%2C%20soft%20natural%20light%2C%20minimal%20miscellaneous%20product%20photography%2C%20varied%20textures%20and%20tones%2C%20tidy%20eclectic%20mood%2C%20clean%20composition&width=600&height=600&seq=cat-other-01&orientation=square&nocache=true',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';